// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"99":"cc0bc26c","143":"34f9ecf0","192":"5e018ed6","295":"ec36de26","349":"efcabfe8","351":"4ac3376d","453":"064bf14a","592":"b704506e","655":"18baccae","813":"bfcb9a1f","866":"676d4b27","927":"ad839eb9","963":"3d4f4e4d"}[chunkId] + ".chunk.js";
};